import React from "react";
import "./At_Our_Tapovan.css";
import parse from "html-react-parser"

const At_Our_Tapovan = ({ data }) => {
  return (
    <section className="At_Our_Tapovan">
      <div className="container">
        <div className="content_div">

          <div className="text_holder">
            <p className="title_text">{data?.name || " "} </p>
            <p className="descn_text">{parse(data?.description || " ")}</p>
            {/* <p className="descn_text">
              Particularly located in Ankleshwar, Om Tapovan is envisioned as a place
              where ancient traditions meet modern understanding. It carries a clear vision
              and mission centered on guiding individuals toward spiritual growth, inner peace,
              and holistic well-being. The environment encourages mindfulness, self-discovery,
              and balance in life, while fostering a deeper connection between body, mind,
              and soul. By integrating timeless wisdom with the advancements of modern science,
              Om Tapovan aspires to create a nurturing space for transformation and harmony.
            </p> */}
          </div>

          <div className="yellow_div"></div>
        </div>
      </div>
    </section>
  );
};

export default At_Our_Tapovan;
